import { defineMessages } from 'react-intl';

export default defineMessages({
    BuildingTitle: {
        id: 'quoteandbind.wizard.Commercial.Policy.Building1',
        defaultMessage: 'Building'
    },
    NotApplicable: {
        id: 'quoteandbind.wizard.Commercial.Policy.NotApplicable1',
        defaultMessage: 'N/A'
    },
    roofUpdate: {
        "id": "quoteandbind.wizard.Commercial.Roofing Update1",
        "defaultMessage": "Roofing Update"
    },
    repairsAdditions: {
        "id": "quoteandbind.wizard.Commercial.Repairs/Additions1",
        "defaultMessage": "Repairs/Additions"
    },
    buildersRisk: {
        "id": "quoteandbind.wizard.Commercial.buildersRisk1",
        "defaultMessage": "Builders Risk Location"
    }
})